/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rg_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I generate numbers without duplicates?`)
};

const es_rg_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo generar números sin duplicados?`)
};

const de_rg_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich Zahlen ohne Duplikate generieren?`)
};

const nl_rg_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik getallen genereren zonder duplicaten?`)
};

const fr_rg_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je générer des nombres sans doublons ?`)
};

const it_rg_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso generare numeri senza duplicati?`)
};

const pt_br2_rg_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso gerar números sem duplicatas?`)
};

const pt_rg_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso gerar números sem duplicados?`)
};

const ja_rg_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複なしで番号を生成できますか？`)
};

const zh_rg_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以生成不重复的数字吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rg_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rg_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rg_faq3_q", locale)
	if (locale === "en") return en_rg_faq3_q(inputs)
	if (locale === "es") return es_rg_faq3_q(inputs)
	if (locale === "de") return de_rg_faq3_q(inputs)
	if (locale === "nl") return nl_rg_faq3_q(inputs)
	if (locale === "fr") return fr_rg_faq3_q(inputs)
	if (locale === "it") return it_rg_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_rg_faq3_q(inputs)
	if (locale === "pt") return pt_rg_faq3_q(inputs)
	if (locale === "ja") return ja_rg_faq3_q(inputs)
	return zh_rg_faq3_q(inputs)
};